import React from "react";
import PropTypes from "prop-types";

const FoldyMapIcon = ({ iconColorClassName, height, width }) => {
  return (
    <svg width={width || "35px"} height={height || "35px"} viewBox="0 0 35 35">
      <g
        id="Desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Course-Detail-1.0"
          transform="translate(-262.000000, -2187.000000)"
          className={iconColorClassName || "white-fill"}
          fillRule="nonzero"
        >
          <g id="Group-13" transform="translate(120.000000, 2186.000000)">
            <path
              d="M164.66537,4.67143066 L154.937743,1.22413773 C154.120623,0.928655484 153.225681,0.928655484 152.40856,1.20443892 L144.645914,3.84408036 C143.070039,4.39564723 142,5.8927573 142,7.58685554 L142,30.9299534 C142,33.7074865 144.743191,35.5985729 147.291829,34.5939333 L152.992218,32.3482682 C153.420233,32.1709788 153.906615,32.1709788 154.33463,32.3285693 L164.062257,35.7758623 C164.879377,36.0713445 165.774319,36.0713445 166.59144,35.7955611 L174.354086,33.1559196 C175.929961,32.6240516 177,31.1072427 177,29.4131445 L177,6.07004665 C177,3.29251349 174.256809,1.40142708 171.708171,2.40606674 L166.007782,4.65173184 C165.579767,4.80932238 165.11284,4.82902119 164.66537,4.67143066 L164.66537,4.67143066 Z M166,32 L154,27.8657475 L154,5 L166,9.13425254 L166,32 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

FoldyMapIcon.propTypes = {
  iconColorClassName: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default FoldyMapIcon;
